import React, { useState, useEffect } from 'react';
import { useTheme } from 'ThemeContext';
import {
  Wrapper,
  IconContainer,
  Temperature,
  Box,
  Text
} from './WidgetWeather.style';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSun,
  faMoon,
  faSnowflake
} from '@fortawesome/free-regular-svg-icons';
import {
  faCloud,
  faCloudSun,
  faCloudMoon,
  faCloudShowersHeavy,
  faCloudMoonRain,
  faCloudSunRain,
  faBolt,
  faSmog
} from '@fortawesome/free-solid-svg-icons';

function WidgetWeather({ textColor, cityName, title = 'Pogoda' }) {
  const [apiData, setApiData] = useState({});
  const theme = useTheme();

  function weatherIcon({ iconName }) {
    let type;

    switch (iconName) {
      case '01d':
        type = faSun;
        break;
      case '02d':
        type = faCloudSun;
        break;
      case '03d':
        type = faCloud;
        break;
      case '04d':
        type = faCloud;
        break;
      case '09d':
        type = faCloudShowersHeavy;
        break;
      case '10d':
        type = faCloudSunRain;
        break;
      case '11d':
        type = faBolt;
        break;
      case '13d':
        type = faSnowflake;
        break;
      case '50d':
        type = faSmog;
        break;

      case '01n':
        type = faMoon;
        break;
      case '02n':
        type = faCloudMoon;
        break;
      case '03n':
        type = faCloud;
        break;
      case '04n':
        type = faCloud;
        break;
      case '09n':
        type = faCloudShowersHeavy;
        break;
      case '10n':
        type = faCloudMoonRain;
        break;
      case '11n':
        type = faBolt;
        break;
      case '13n':
        type = faSnowflake;
        break;
      case '50n':
        type = faSmog;
        break;

      default:
        type = '';
    }
    return type;
  }

  // API KEY AND URL
  const apiKey = process.env.REACT_APP_API_WEATHER_KEY;
  const apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${cityName}&appid=${apiKey}`;

  const kelvinToCelsius = k => {
    return (k - 273.15).toFixed(0);
  };
  // Side effect
  useEffect(() => {
    fetch(apiUrl)
      .then(res => res.json())
      .then(data => setApiData(data));
  }, [apiUrl]);

  return (
    <Wrapper>
      {apiData.main && (
        <Box textColor={textColor} theme={theme.widgetWeather.box}>
          <Text theme={theme.widgetWeather.text}>{title}</Text>

          <IconContainer theme={theme.widgetWeather.iconContainer}>
            <FontAwesomeIcon
              icon={weatherIcon({ iconName: `${apiData.weather[0].icon}` })}
            />
          </IconContainer>
          <Temperature theme={theme.widgetWeather.temperature}>
            {kelvinToCelsius(apiData.main.temp)}&deg;
          </Temperature>
        </Box>
      )}
    </Wrapper>
  );
}

export default WidgetWeather;
